import * as React from 'react'
import { useParams } from 'react-router-dom';
import SubscriptionList from '../../components/molecules/SubscriptionList';
import { Body } from '../../components/templates/Wrappers';
import { getIncognitoInvestorChannels } from '../../globals/ApiHooks';
import { InvestmentId } from '../../shared/Investment';
import { Channel } from '../../shared/Post';

export const EditChannels: React.FC = () => {
  const { id } = useParams<{ id: InvestmentId }>()
  const [projectChannels, setProjectChannels] = React.useState<Channel[]>()
  const [defaultChannels, setDefaultChannels] = React.useState<Channel[]>()
  const [investorChannels, setInvestorChannels] = React.useState<string[]>()

  React.useEffect(() => {
    (async () => {
      const result = await getIncognitoInvestorChannels(id)
      if (result?.defaultChannels) setDefaultChannels(result.defaultChannels)
      if (result?.projectChannels) setProjectChannels(result.projectChannels)
      if (result?.investorChannels) setInvestorChannels(result.investorChannels)

    })()
  }, [id])

  return (
    <Body>
      <div style={{ textAlign: 'center' }}>
        <div style={{ width: 400, margin: 'auto', marginTop: 40 }}>
          <div className="card padding">
            <img
              width="250px"
              src="https://prod-attachments-bucket-fb-2-0.s3.eu-west-1.amazonaws.com/59c23268-89c9-4132-9a6c-c97a7aa61eff.png"
              alt="Fundbricks logo" />
          </div>
          <SubscriptionList investorId={id} investorChannels={investorChannels} defaultChannels={defaultChannels} projectChannels={projectChannels} />
        </div>
      </div>
    </Body>
  )
};
